/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {
    retrieveSchema,
    getDefaultRegistry,
    optionsList,
    getUiOptions,
    getWidget
} from "react-jsonschema-form/lib/utils";
import DataTable from "../../DataTable";
import Schema from "../../../../Schema";
import {PageAction, PageActionActions} from "../../../../services/PageAction";
import ActionButtons from "../../ActionButtons";
import LocationInfo from "../../../../LocationInfo";
import {SessionStore} from "../../../../services/Session";

class ArrayField extends React.Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        uiSchema: PropTypes.shape({
            "ui:options": PropTypes.shape({
                addable: PropTypes.bool,
                orderable: PropTypes.bool,
                removable: PropTypes.bool,
            }),
        }),
        idSchema: PropTypes.object,
        name: PropTypes.string,
        errorSchema: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        formData: PropTypes.array,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        readonly: PropTypes.bool,
        autofocus: PropTypes.bool,
        registry: PropTypes.shape({
            widgets: PropTypes.objectOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object])
            ).isRequired,
            fields: PropTypes.objectOf(PropTypes.func).isRequired,
            definitions: PropTypes.object.isRequired,
            formContext: PropTypes.shape({
                expanded: PropTypes.bool,
                expandedCallback: PropTypes.func,
                onSubmit: PropTypes.func,
                locale: PropTypes.string,
                location: PropTypes.object,
                params: PropTypes.shape({
                    path: PropTypes.string.isRequired,
                    fieldPath: PropTypes.string.isRequired,
                    resource: PropTypes.string.isRequired,
                    action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
                    id: PropTypes.string,
                    query: PropTypes.object,
                    parentPath: PropTypes.string,
                    parentFieldPath: PropTypes.string,
                    parentResource: PropTypes.string,
                    parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
                    parentId: PropTypes.string,
                    parentField: PropTypes.string
                })
            }).isRequired,
        })
    };

    static defaultProps = {
        uiSchema: {},
        formData: [],
        errorSchema: {},
        idSchema: {},
        required: false,
        disabled: false,
        readonly: false
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.onAction = this.onAction.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
    }

    render() {
        if (this.isMultiSelect(this.props.schema)) return this.renderMultiSelect();

        let schema = new Schema(this.props.schema, this.props.uiSchema, null);
        let recSchema = schema.field("*");
        let actions = schema.uiSchema.getAction();
        let recActions = recSchema.uiSchema.getAction();
        let sort = recSchema.getOrder();
        return (
            <div>
                <div className="row">
                    {this.renderActions(actions)}
                </div>
                <div className="row">
                    <DataTable
                        schema={schema}
                        data={this.props.formData}
                        actions={recActions}
                        pageSize={0}
                        size="small"
                        onAction={this.onAction}
                        internalSort={true}
                        sort={sort}
                        location={this.props.registry.formContext.location}
                    />
                </div>
            </div>
        );
    }

    isMultiSelect(schema) {
        return (schema.items && schema.items.type !== "object");
    }

    renderMultiSelect() {
        const {
            schema,
            idSchema,
            uiSchema,
            formData,
            disabled,
            readonly,
            autofocus,
            onBlur,
            onFocus,
            registry = getDefaultRegistry(),
        } = this.props;
        const items = this.props.formData;
        const { widgets, definitions, formContext } = registry;
        const itemsSchema = retrieveSchema(schema.items, definitions, formData);
        let enumOptions = [];
        if (itemsSchema.enum) enumOptions = optionsList(itemsSchema);
        const { widget = "select", ...options } = {
            ...getUiOptions(uiSchema),
            enumOptions,
        };
        const Widget = getWidget(schema, widget, widgets);
        return (
            <Widget
                id={idSchema && idSchema.$id}
                multiple
                onChange={this.onSelectChange}
                onBlur={onBlur}
                onFocus={onFocus}
                options={options}
                schema={schema}
                value={items}
                disabled={disabled}
                readonly={readonly}
                formContext={formContext}
                autofocus={autofocus}
            />
        );
    }

    fieldProps() {
        let name = this.props.name;
        // Array fields contain in JSON Schema "items" subelement, but UI Schema does not. Remove this:
        if (name.endsWith("/items")) name = name.substring(0, name.length-6);
        let locationInfo = new LocationInfo();
        return locationInfo.makeSubfieldProps(this.props.registry.formContext.params, name);
    }

    onAction(action, data) {
        let pageAction = new PageAction(action);
        pageAction.params = this.fieldProps();
        if (data) pageAction.data = data;
        PageActionActions.callAction(pageAction);
    }

    renderActions(actions) {
        if (!actions || actions.length == 0) return null;
        return (
            <div className="list-actions">
                <ActionButtons className="btn-group-xs" actions={actions} onAction={this.onAction} location={this.props.registry.formContext.location}/>
            </div>
        );
    }

    onSelectChange(value) {
        this.props.onChange(value);
    }
}

export default ArrayField;
